import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, tap } from 'rxjs';
import { PaymentSettingsService } from 'src/app/shared/services/payment-settings.service';
import {
  loadPaymentSettings,
  loadPaymentSettingsSuccess,
  savePaymentSettings,
  deletePaymentSettings,
  updatePaymentSettings,
  loadPaymentSettingsCurrent,
  loadPaymentSettingsCurrentSuccess,
} from './payment-settings.actions';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class PaymentSettingsEffects {
  constructor(
    private service: PaymentSettingsService,
    private action$: Actions,
    private notify: NotifyService
  ) { }

  loadPaymentSettings$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadPaymentSettings),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadPaymentSettingsSuccess({ paymentSettings: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  loadPaymentSettingsCurrent$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadPaymentSettingsCurrent),
      concatMap(({ id }) =>
        this.service.get(id).pipe(
          map((res) =>
            loadPaymentSettingsCurrentSuccess({ paymentSettings: res })
          ),
          catchError((error) => {
            this.notify.emitError('Falha ao carregar registros')
            return of(error.error['hydra:description'])
          })
        )
      )
    )
  );

  savePaymentSettings$ = createEffect(() =>
    this.action$.pipe(
      ofType(savePaymentSettings),
      concatMap(({ paymentSettings }) =>
        this.service.save(paymentSettings).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => loadPaymentSettings()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  editPaymentSettings$ = createEffect(() =>
    this.action$.pipe(
      ofType(updatePaymentSettings),
      concatMap(({ paymentSettings, id }) =>
        this.service.edit(paymentSettings, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => loadPaymentSettings()),
          map((res) => loadPaymentSettingsCurrent({ id: id })),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );

  deletePaymentSettings$ = createEffect(() =>
    this.action$.pipe(
      ofType(deletePaymentSettings),
      concatMap(({ id }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => loadPaymentSettings()),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(error.error['hydra:description']);
          })
        )
      )
    )
  );
}
